import React from 'react'
import styled from '@emotion/styled'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Wrapper = styled.div`
  width: 100%;
  background-color: #fbfbfd;
`

type Props = {
  children?: any
}

const HeaderContainer = ({ children }: Props) => (
  <Container>
    <Wrapper>{children}</Wrapper>
  </Container>
)

export default HeaderContainer
